import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, of, throwError } from 'rxjs';
import { FacilityModel } from 'src/app/models/facility';
import { MessagesService } from './messages.service';
import { FacilitiesFacade } from './facades/facilities/facilities.facade';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { UserFacade } from 'src/app/services/facades/user/user.facade';
import { NotificationsFacade } from './facades/notifications/notifications.facade';
import { ServicedStatesFacade } from './facades/serviced-states/serviced-states.facade';
import { NavigationExtras, Router } from '@angular/router';
import { FacilitiesActions } from '../state/actions/facilities/facilities-action-types';
import { FetchFacilityByIdDTO } from '../state/actions/facilities/dto/fetch-facility-by-id';
import { LoaderService } from './ui/loader.service';

@Injectable({
  providedIn: 'root'
})
export class SelectFacilityService {
  constructor(
    private messages: MessagesService,
    private facilitiesFacade: FacilitiesFacade,
    private userFacade: UserFacade,
    private notificationsFacade: NotificationsFacade,
    private servicedStatesFacade: ServicedStatesFacade,
    public router: Router,
    private loader: LoaderService
  ) { }

  selectFacility(facility: Partial<FacilityModel>, withParams = false) {
    if (facility.deactivationStatus === 'Deactivated') {
      this.messages.add('The facility has been deactivated. If you have any questions please, please contact support.', '', 'danger', () => {
        window.location.href = 'mailto:support@eshyft.com?subject=Facility status inquiry';
      }, true, 'Contact support');
      return;
    }
    this.loader.create('Loading...')
    this.facilitiesFacade.fetchActiveFacilityModel(facility._id).pipe(
      take(1),
      tap(()=>this.loader.hide()),
      switchMap((action) => {
        if(action.type === FacilitiesActions.fetchActiveFacilityModelFailed.type){
          return throwError(()=> new Error((action as FetchFacilityByIdDTO.Failed).error.error.message || 'Failed to fetch active facility model.'));
        }
        if(action.type === FacilitiesActions.fetchActiveFacilityModelSuccess.type){
          const facility = (action as FetchFacilityByIdDTO.Success).model;
          return this.servicedStatesFacade.fetchState(facility.address.state).pipe(
            take(1),
            catchError((error) => {
              console.error('Error fetching state:', error);
              return of(null); 
            })
          );
        }
        return of(null);
      }),  
    ).subscribe((state)=>{
      if (state) {
        this.servicedStatesFacade.setActive(state['model'].state);
      }
      this.notificationsFacade.fetchNotifications().pipe(take(1)).subscribe();
      this.setLocalStorage(facility._id);
      const currentUrl = this.router.url;
      if (!facility.isBlockScheduleEnabled && currentUrl.includes('manager/shifts/block-schedule')) {
        this.router.navigateByUrl('/manager/shifts/applicants');
      } else {
        this.reloadPage(withParams);
      }
    }, 
    (error)=>{
      this.messages.add('Error when retreiving active facility. Please try again later.', error, 'danger');
    });

  }
  setLocalStorage(facilityId){
    let activeFacilities = JSON.parse(localStorage.getItem('activeFacilities'));
    let userId;
    this.userFacade.state.user$.pipe(take(1)).subscribe((u) => {
      userId = u._id;
    });
    activeFacilities.find((e) => e.userId == userId).activeFacilityId = facilityId;
    localStorage.setItem('activeFacilities', JSON.stringify(activeFacilities));
    this.notificationsFacade.fetchNotifications().pipe(take(1)).subscribe();



  }
  reloadPage(withParams) {
    const currentUrl = this.router.url;
    const urlTree = this.router.parseUrl(currentUrl);
    const queryParams = urlTree.queryParams;
    const navigationExtras: NavigationExtras = {
      queryParams: queryParams,
      queryParamsHandling: "merge",
    };
    this.router.navigateByUrl('/manager/facility-selection').then(() => {
      if(withParams){
        this.router.navigateByUrl(currentUrl, navigationExtras);
      }else{
        
        const emptyUrl = currentUrl.replace(/\?.*$/, '');
        this.router.navigateByUrl(emptyUrl);
      }
    });
  }
}
